import React, { Component } from 'react';
import Button from 'components/button/ActionButton';
import { ActivateIcon } from 'assets/materialIcons/materialIcons';
import PropTypes from 'prop-types';
import theme from 'theme/theme';
import translate from 'components/hoc/translate';
import { compose } from 'redux';
import { connect } from 'react-redux';
import config from 'helpers/config';
import apiClient from 'clients/apiClient';

class ConfirmButton extends Component {
    handleClick = () => {
        const {
            onFailure,
            onSuccess,
        } = this.props;

        return this.postRequest().then((response) => {
            return onSuccess(response);
        },
        (error) => {
            return onFailure(error);
        });
    }

    postRequest = () => {
        const {
            record,
            resource,
        } = this.props;

        const url = `${ config.getApiBaseUrl() }/${ resource }/${ record.id }/confirm`;

        return apiClient.create(url);
    }

    render() {
        const {
            translate,
        } = this.props;

        return (
            <Button
                icon={ <ActivateIcon color={ theme.palette.doveGray } /> }
                title={ translate('actions.confirm') }
                onClick={ this.handleClick }
            />
        );
    }
}

ConfirmButton.propTypes = {
    onFailure: PropTypes.func,
    onSuccess: PropTypes.func,
    record: PropTypes.object,
    resource: PropTypes.string,
    translate: PropTypes.func,
};

const mapDispatchToProps = (dispatch, props) => {
    const {
        failureAction,
        successAction,
    } = props;

    return {
        onFailure: (error) => {
            dispatch(failureAction(error));
        },
        onSuccess: (response) => {
            dispatch(successAction(response));
        },
    };
};

const enhance = compose(
    connect(null, mapDispatchToProps),
    translate,
);

export default enhance(ConfirmButton);


// WEBPACK FOOTER //
// ./src/components/button/ConfirmButton.js